import { render, staticRenderFns } from "./create-password-aws.vue?vue&type=template&id=c673d1e4&scoped=true&"
import script from "./create-password-aws.vue?vue&type=script&lang=js&"
export * from "./create-password-aws.vue?vue&type=script&lang=js&"
import style0 from "@/assets/auth-screen.scss?vue&type=style&index=0&id=c673d1e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c673d1e4",
  null
  
)

component.options.__file = "create-password-aws.vue"
export default component.exports